import { formatDateToInput } from '../utils/formatDate';

export function mapCustomerToFormValues(customer) {
  if (!customer) return {};
  return {
    customerId: customer.customerId || '',
    account: customer.user_account || '',
    dimension: customer.dimension || '',
    expiresAt: formatDateToInput(customer.expiresAt || ''),
  };
}